var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "start-dispute__popup" }, [
    _c("div", { staticClass: "start-dispute__popup-title" }, [
      _vm._v(_vm._s(_vm.i18n.cont_start_a_dispute()))
    ]),
    _vm._v(" "),
    _c(
      "form",
      {
        staticClass: "start-dispute__form",
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.submit.apply(null, arguments)
          }
        }
      },
      [
        _c("div", { staticClass: "start-dispute__row" }, [
          _c(
            "div",
            { staticClass: "start-dispute__field" },
            [
              _c("h3", { staticClass: "start-dispute__field-title" }, [
                _vm._v(_vm._s(_vm.i18n.lbl_document()))
              ]),
              _vm._v(" "),
              _c("file-field", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                attrs: {
                  fileType: "image",
                  name: "dispute-file",
                  type: _vm.documentTypes.dispute
                },
                model: {
                  value: _vm.documents.dispute,
                  callback: function($$v) {
                    _vm.$set(_vm.documents, "dispute", $$v)
                  },
                  expression: "documents.dispute"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "start-dispute__field" },
            [
              _c("h3", { staticClass: "start-dispute__field-title" }, [
                _vm._v(_vm._s(_vm.i18n.lbl_note()))
              ]),
              _vm._v(" "),
              _c("textarea-field", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                attrs: { name: "dispute-note" },
                model: {
                  value: _vm.form.note,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "note", $$v)
                  },
                  expression: "form.note"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "start-dispute__submit-wrapper" },
          [
            _c(
              "md-button",
              {
                staticClass: "md-primary",
                attrs: { type: "submit", disabled: _vm.isPending }
              },
              [_vm._v(_vm._s(_vm.i18n.lbl_submit()))]
            )
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a971b8e6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a971b8e6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/contracts/index/modals/Contracts.StartDispute.vue
// module id = wL3c
// module chunks = 1